import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, shallowRef, watch } from "vue"

import ProductCode from "@/components/Common/ProductCode"
import type { ExistedProduct, ExistedProductAttribute } from "@/modules/offers/types/catalog"
import offersService from "@/services/offersService"

import ProductGallery from "./ProductGallery.vue"

type Props = {
  choosenExistingProduct: ExistedProduct
}
type Emits = {
  (event: "closeProductDetails"): void
  (event: "selectExistedProduct", product: ExistedProduct): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExistedProductDetails',
  props: {
    choosenExistingProduct: null
  },
  emits: ["closeProductDetails", "selectExistedProduct"],
  setup(__props: any, { emit }: { emit: ({
  (event: "closeProductDetails"): void
  (event: "selectExistedProduct", product: ExistedProduct): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  choosenExistingProduct: ExistedProduct
};




const product = ref<ExistedProduct>()
const isFetching = shallowRef<boolean>(true)

const productImages = computed<Array<string>>(() => product.value?.images || [])
const productAttributes = computed<Array<ExistedProductAttribute>>(() => [
  ...(product.value?.attrs_main || []),
  ...(product.value?.attrs_full || [])
])

const setupProduct = async () => {
  product.value = undefined

  try {
    isFetching.value = true

    const { data } = await offersService.fetchProductInfo({
      code: props.choosenExistingProduct.p_code
    })
    product.value = data
  } finally {
    isFetching.value = false
  }
}
const onCloseProductDetails = () => {
  emit("closeProductDetails")
}
const onSelect = () => {
  emit("selectExistedProduct", product.value)
  onCloseProductDetails()
}

watch(() => props.choosenExistingProduct.p_code, setupProduct)

onMounted(setupProduct)

return { __sfc: true,props, emit, product, isFetching, productImages, productAttributes, setupProduct, onCloseProductDetails, onSelect, ProductCode, ProductGallery }
}

})